import { render, staticRenderFns } from "./CommanderDamage.vue?vue&type=template&id=5fb485a4&scoped=true&"
import script from "./CommanderDamage.vue?vue&type=script&lang=js&"
export * from "./CommanderDamage.vue?vue&type=script&lang=js&"
import style0 from "./CommanderDamage.vue?vue&type=style&index=0&id=5fb485a4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb485a4",
  null
  
)

export default component.exports